module.exports = __webpack_public_path__ + "img/alipay.a94da82c.png";